import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const Text = styled.p`
    width: 66.66666667%;
    font-size: 16px;
    color: #777777;
    font-weight: normal;
    line-height: 1.66em;
    text-align: center;
    position: relative;
    ${({line}) =>line==='before'?"padding-top: 33px;":"padding-bottom: 33px;"}
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        ${({line}) =>line==='before'?"top: 17px;":"bottom: 17px;"}
        right: 50%;
        transform: translateX(50%);
    }
`
export const Link = styled.a`
    color: #2e2e2e;
    transition: 0.2s;
    &:hover{
        color: #00a0e7;
    }
`
